import settings from '@/settings'

const pegarPorCodigo = (headers, data) => {
  let url = `${settings.apetrusApi}/compras/pegar-por-codigo/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

let pegarComprasCashPosto = (headers, data) => {
  let url = `${settings.apetrusApi}/compras/compras-de-cashposto/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

// Dar baixar em todas as compras pós pagas
const darBaixarEmTodos = (data, headers) => {
  return fetch(`${settings.apetrusApi}/compras/darbaixaremtodos/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

// Cancelar compra em espécie
const cancelarCompra = (data, headers) => {
  return fetch(`${settings.apetrusApi}/compras/cancelarcompra/`, {
    method: 'POST',
    mode: 'cors',
    body: JSON.stringify(data),
    cache: 'default',
    headers: headers
  })
}

const comprasEmDinheiro = (data, headers) => {
  let url = `${settings.apetrusApi}/compras/compraspospago/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

const deAssinatura = (data, headers) => {
  let url = `${settings.apetrusApi}/compras/assinatura/`
  if (data) {
    const keys = Object.keys(data)
    for (let i = 0; i < keys.length; i++) {
      url = `${url}${url[url.length - 1] === '/' ? '?' : '&'}${keys[i]}=${data[keys[i]]}`
    }
  }
  return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
  pegarPorCodigo,
  pegarComprasCashPosto,
  darBaixarEmTodos,
  cancelarCompra,
  comprasEmDinheiro,
  deAssinatura
}
